import Swal from "sweetalert2";
import 'sweetalert2/src/sweetalert2.scss';
import "../../components/swalStyle/customStyle.css";

export const alertMinus = async (id, deleteAction) => {
    const swalWithBootstrapButtons = Swal.mixin();
    const res = await swalWithBootstrapButtons.fire({
        title: "Delete",
        html: 'Want to delete this information?<br/>ต้องการลบข้อมูลนี้หรือไม่?',
        iconHtml: '<img src="https://img2.pic.in.th/pic/ic-delete.png">',
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "NO",
        reverseButtons: true,
    });

    if (res.isConfirmed) {
        try {
            const response = await deleteAction(id);
            if (response.data.status === "success") {
                await Swal.fire({
                    icon: "success",
                    title: "Deleted Successfully!",
                    text: "ลบรายการสำเร็จ!"
                });
                window.location.reload();
            }
        } catch (error) {
            console.error(error);
        }
    }
};

export const alertValidateData = async () => {
    return await Swal.fire({
        iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
        title: "Please fill your information completely.",
        text: "กรุณากรอกข้อมูลให้ครบถ้วน",
        confirmButtonText: "CLOSE",
    });
};

export const alertOverLimit = async () => {
    return await Swal.fire({
        iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
        title: "Text",
        text: "กรอกข้อมูลเกินกำหนด",
        confirmButtonText: "CLOSE",
    });
};

export const alertConfirmChange = async () => {
    return await Swal.fire({
        title: "The entered information will be lost. Want to change your options?",
        text: "ข้อมูลที่ใส่ไว้จะหาย ต้องการเปลี่ยนตัวเลือกใช่ไหม?",
        iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "CONFIRM",
        cancelButtonText: "CANCEL",
    });
};

export const alertErrorExistsUsernameOrEmail = async () => {
    return await Swal.fire({
        icon: "error",
        title: "Email or username is taken, try another.",
        text: "อีเมล หรือ username ถูกใช้ไปแล้ว",
    });
};

export const alertConfirmSave = async () => {
    return await Swal.fire({
        title: "Confirm Data Save.",
        text: "ยืนยันการบันทึกข้อมูล",
        iconHtml: '<img src="https://img5.pic.in.th/file/secure-sv1/ic-save.png">',
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "CONFIRM",
        cancelButtonText: "CANCEL",
    });
};

export const alertSaved = async () => {
    return await Swal.fire({
        icon: "success",
        title: "Saved",
        text: "บันทึกเรียบร้อยแล้ว",
    });
};

export const alertCancel = async () => {
    return await Swal.fire({
        iconHtml: '<img src="https://img2.pic.in.th/pic/ic-warnning.png">',
        title: 'Cancel',
        text: 'ไม่บันทึกข้อมูล',
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "CONFIRM",
        cancelButtonText: "CANCEL",
    });
};

export const alertNotFound = async () => {
    await Swal.fire({
        icon: "error",
        title: "Not found!",
        text: "ไม่พบเนื้อหาที่คุณต้องการกรุณาตรวจสอบข้อมูลอีกครั้ง!",
    });
};

export const alertKeySpaceBar = async () => {
    await Swal.fire({
        title: "No spaces are allowed in the username or password.",
        iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
        text: "ไม่อนุญาตให้เว้นวรรคในชื่อผู้ใช้หรือรหัสผ่าน",
    });
};

export const alertKeyLangTH = async () => {
    await Swal.fire({
        title: "Incorrect.",
        iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
        text: "กรุณากรอกเฉพาะภาษาอังกฤษ",
    });
};

export const alertRequired = async () => {
    await Swal.fire({
        iconHtml: '<img src="https://img5.pic.in.th/file/secure-sv1/Group-2965296b3f13a7a414ce.png">',
        title: "Please enter username and password.",
        text: "จำเป็นต้องกรอกข้อมูล",
        confirmButtonText: "CLOSE",
    });
};

export const alertLoginSuccess = async (redirectUrl) => {
    await Swal.fire({
        iconHtml: '<img src="https://img2.pic.in.th/pic/ic-success-green.png">',
        title: "Login Success.",
        text: "เข้าสู่ระบบสำเร็จ",
        confirmButtonText: "CLOSE",
    }).then(() => {
        window.location.href = redirectUrl;
    });
};

export const alertIncorrectLogin = async () => {
    await Swal.fire({
        iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
        title: "Incorrect username or password.",
        text: "Username/Password ไม่ถูกต้อง",
        confirmButtonText: "OK",
    });
}

export const alertError = async () => {
    await Swal.fire({
        iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
        title: 'An error occurred! Please try again.',
        text: "เกิดข้อผิดพลาด! กรุณาลองอีกครั้ง.",
        confirmButtonText: 'OK',
    });
}

export const alertEnterPassword = async () => {
    await Swal.fire({
        iconHtml: '<img src="https://img5.pic.in.th/file/secure-sv1/ic-login.png">',
        title: "Please enter password.",
        text: "กรุณากรอกรหัสผ่าน",
        confirmButtonText: "CLOSE",
    });
}

export const alertChangePassword = async () => {
    await Swal.fire({
        iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
        title: "Unable to change password.",
        text: "ไม่สามารถเปลี่ยนรหัสผ่านได้",
        confirmButtonText: "CLOSE",
    });
}

export const alertChangePasswordCase = async () => {
    await Swal.fire({
        iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
        title: "Unable to change password.",
        text: "ไม่สามารถเปลี่ยนรหัสผ่านได้",
        confirmButtonText: "CLOSE",
    });
}

export const alertClickBack = async () => {
    return await Swal.fire({
        iconHtml: '<img src="https://img2.pic.in.th/pic/ic-warnning.png">',
        title: 'Back',
        text: 'ย้อนกลับ',
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "CONFIRM",
        cancelButtonText: "CANCEL",
    });
}

export const alertEnterEmail = () => {
    Swal.fire({
        iconHtml: '<img src="https://img5.pic.in.th/file/secure-sv1/ic-email-gray.png">',
        title: "Please enter email.",
        text: "กรุณากรอกอีเมล",
        confirmButtonText: "CLOSE",
    });
}

export const alertIncorrectEmail = () => {
    Swal.fire({
        iconHtml: '<img src="https://img5.pic.in.th/file/secure-sv1/ic-email-gray.png">',
        title: "Please enter your email address correctly.",
        text: "กรุณากรอกอีเมลให้ถูกต้อง",
        confirmButtonText: "CLOSE",
    });
}

export const alertSendEamil = () => {
    Swal.fire({
        iconHtml: '<img src="https://img2.pic.in.th/pic/ic-success-green.png">',
        title: 'The system will send you email to change your password.',
        text: 'ระบบจะส่งข้อมูลการแก้ไขรหัสผ่านใหม่ให้คุณทางอีเมล',
        confirmButtonText: 'OK',
    });
}